import React from 'react';

import { COMPANY_HUB_SETTINGS_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { CompanyHomeBuilderUpsellPage } from '@confluence/change-edition/entry-points/CompanyHomeBuilderUpsellPage.ts';
import {
	CompanyHubSettingsPage,
	CompanyHubSettingsPageTabsType,
} from '@confluence/company-hub/entry-points/CompanyHubSettingsPage.ts';
import { useCompanyHubPremiumGate } from '@confluence/company-hub-utils/entry-points/useCompanyHubPremiumGate.ts';
import { COMPANY_HUB_ANALYTICS } from '@confluence/named-routes/entry-points/routes.ts';
import { getCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { getCompanyHubPseudoAppRoute } from '@confluence/ssr-app/entry-points/getCompanyHubPseudoAppRoute.ts';
import type { RouteWithNavParamsType } from '@confluence/ssr-app/entry-points/routes.ts';

/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */
function ConfluenceAppHubAnalyticsRoute() {
	const shouldShowPremiumUpsell = useCompanyHubPremiumGate();

	if (shouldShowPremiumUpsell) {
		return <CompanyHomeBuilderUpsellPage featureName="companyHub" />;
	}

	return <CompanyHubSettingsPage tab={CompanyHubSettingsPageTabsType.ANALYTICS} />;
}

ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = () => {
	const spaceKey = getCompanyHubSpaceKey();
	const navView = COMPANY_HUB_SETTINGS_ID;

	return {
		Screen: {
			screenEvent: {
				name: 'companyHubAnalytics',
			},
			pageState: {
				routeName: COMPANY_HUB_ANALYTICS.name,
				spaceKey,
			},
		},
		MainLayout: {
			navView,
		},
	};
};

/**
 * The route "Company Hub settings > Analytics" in the Company Hub pseudo app if enabled; otherwise, in the Confluence app.
 */
export const CompanyHubAnalyticsRoute: RouteWithNavParamsType = getCompanyHubPseudoAppRoute(
	ConfluenceAppHubAnalyticsRoute,
);
